import React, { useEffect, createContext, useState } from 'react';
import { useMemo } from 'react';
import { demoPages } from '../menu';
import { useLocation, useNavigate } from 'react-router-dom';
export const userAuth = createContext({});

const UserContextProvider = ({ children }) => {
	const [token, setToken] = useState({});
	const [menudemopages, setMenudemopages] = useState({ ...demoPages });
	//
	const [loading, setLoading] = useState(true);
	const [reset, setReset] = useState(true);
	const location = useLocation();
	const navigate = useNavigate();
	const [pathpermission, setPathpermission] = useState([]);

	const sitemenu = useMemo(() => {
		return [
			{
				value: 'appointments',
				key: 'vbookingPages',
				active: false,
				subMenu: [
					{
						value: 'Pending Appointments',
						key: 'v_book',
						active: false,
						path: '/appointment/pending',
					},
					{
						value: 'Cancelled Appointments',
						key: 'v_cancelled_book',
						active: false,
						path: '/appointment/cancelled',
					},
					{
						value: 'Completed Appointments',
						key: 'v_completed_book',
						active: false,
						path: '/appointment/completed',
					},
					{
						value: 'Expired Appointments',
						key: 'v_expired_book',
						active: false,
						path: '/appointment/expired',
					},
				],
			},
			{
				value: 'orders',
				key: 'Orders_v',
				active: false,
				path: '/orders',
			},
			{
				value: 'employee',
				key: 'Manage_e',
				active: false,
				subMenu: [
					{
						value: 'Leave Requests',
						key: 'emp_leave',
						active: false,
						path: '/employee/leave-requests',
					},
					{
						value: 'Employee',
						key: 'emp_list',
						active: false,
						path: '/employee/list',
					},
					{
						value: 'Shifts',
						key: 'emp_shed',
						active: false,
						path: '/employee/shifts',
					},
					{
						value: 'Worker Schedule',
						key: 'emp_work_shed',
						active: false,
						path: '/employee/worker-schedule',
					},
				],
			},

			{
				value: 'reports',
				key: 'e_reports',
				active: true,
			},
			{
				value: 'Past Bookings',
				key: 'e_complete',
				active: true,
			},
			{
				value: 'Upcoming Bookings',
				key: 'e_pending',
				active: true,
			},
			{
				value: 'leave',
				key: 'employeeLeave',
				active: true,
			},
			{
				value: 'reports',
				key: 'Manage_report',
				active: false,
				subMenu: [
					{
						value: 'Orders',
						key: 'orders',
						active: false,
						path: '/reports/orders',
					},
					{
						value: 'Appointments',
						key: 'appointment',
						active: false,
						path: '/reports/appointments',
					},
					{
						value: 'Attendance',
						key: 'attendance',
						active: false,
						path: '/reports/attendance',
					},
					{
						value: 'Completed Refund',
						key: 'crefund',
						active: false,
						path: '/reports/completed-refund',
					},
					{
						value: 'Commission',
						key: 'manage_comm',
						active: false,
						path: '/reports/commission',
					},
					{
						value: 'Payments',
						key: 'payment',
						active: false,
						path: '/reports/payments',
					},
					{
						value: 'Pending Refund',
						key: 'prefund',
						active: false,
						path: '/reports/pending-refund',
					},
					{
						value: 'Products',
						key: 'product',
						active: false,
						path: '/reports/products',
					},
					{
						value: 'Schedule',
						key: 'shedule',
						active: false,
						path: '/reports/schedule',
					},
				],
			},
			{
				value: 'customers',
				key: 'Manage_u',
				active: false,
				path: '/customers',
			},
			{
				value: 'accounts',
				key: 'Transaction',
				active: false,
				subMenu: [
					{
						value: 'Cheque',
						key: 'cheque',
						active: false,
						path: '/transaction/cheque',
					},
					{
						value: 'Expenses',
						key: 'expences',
						active: false,
						path: '/transaction/expences',
					},
					{
						value: 'Expences Type',
						key: 'extype',
						active: false,
						path: '/transaction/extype',
					},
					{
						value: 'Income',
						key: 'income',
						active: false,
						path: '/transaction/income',
					},
					{
						value: 'Payroll',
						key: 'manage_pay',
						active: false,
						path: '/transaction/payroll',
					},
				],
			},
			{
				value: 'services',
				key: 'servicePages',
				active: false,
				subMenu: [
					{
						value: 'Promotions',
						key: 'add_promo',
						active: false,
						path: '/services/promotions',
					},
					{
						value: 'Services',
						key: 'add_serv',
						active: false,
						path: '/services/list',
					},
					{
						value: 'Category',
						key: 'add_cat',
						active: false,
						path: '/services/category',
					},
				],
			},
			{
				value: 'refunds',
				key: 'Manage_refunds',
				active: false,
				subMenu: [
					{
						value: 'Pending refunds',
						key: 'refund_list',
						active: false,
						path: '/refunds/requested',
					},
					{
						value: 'Completed refunds',
						key: 'refund_paid',
						active: false,
						path: '/refunds/completed',
					},
				],
			},
			{
				value: 'products',
				key: 'addProduct',
				active: false,
				path: '/viewproducts',
			},
			{
				value: 'sliders',
				key: 'sliderSetting',
				active: false,
				path: '/sliders',
			},
			{
				value: 'branches',
				key: 'branchList',
				active: false,
				path: '/branch',
			},
		];
	}, [token?.session_key]);
	// }, [reset,token]);

	useEffect(() => {
		const gettoken = JSON.parse(localStorage.getItem('user-auth'));
		if (gettoken) {
			setToken(gettoken);
		}
	}, []);

	useEffect(() => {
		if (token.user_roles_id) {
			if (token.is_worker_emp === 1 && token.permission.length > 0) {
			// if (token.user_roles_id === 2 && token.permission.length > 0) {
				const tempmap = [...sitemenu];
				const temp = { ...demoPages };

				tempmap.forEach((b, i) => {
					let mainindex;
					if (
						token.permission.some((Item, r) => {
							if (Item.parent_module == b.value) {
								mainindex = r;
								return true;
							}
							return false;
						})
					) {
						tempmap[i].active = true;
						if (tempmap[i].subMenu !== undefined) {
							const submenu = [...tempmap[i].subMenu];
							submenu.forEach((a, s) => {
								let tempindex;

								if (
									token.permission.some((Sub, i) => {
										if (Sub.module_name == a.value) {
											tempindex = i;
											return true;
										}
										return false;
									})
								) {
									submenu[s].active = true;
									if (tempindex != undefined) {
										setPathpermission((p) => {
											const temp = [...p];
											const index = temp.findIndex((r) => {
												return r.path == a.path;
											});
											if (index !== -1) {
												const term = { ...temp[index] };
												term.permission =
													token.permission[tempindex].permission;
												temp[index] = term;
											} else {
												temp.push({
													path: a.path,
													permission:
														token.permission[tempindex].permission,
												});
											}

											return temp;
										});
									}
								}
							});
							tempmap[i].subMenu = submenu;
						} else {
							if (mainindex != undefined) {
								if (token.permission[mainindex].permission != undefined) {
									setPathpermission((p) => {
										const temp = [...p];
										temp.push({
											path: b.path,
											permission: token.permission[mainindex].permission,
										});
										return temp;
									});
								}
							}
						}
					}
				});
				tempmap.forEach((b) => {
					if (!b.active) {
						delete temp[b.key];
					} else {
						if (b.subMenu !== undefined) {
							b.subMenu.forEach((q) => {
								if (!q.active) {
									temp[b.key].subMenu[q.key].hide = true;
								} else {
									if (temp[b.key].subMenu[q.key] != undefined) {
										temp[b.key].subMenu[q.key].hide = false;
									}
								}
							});
						}
					}
				});

				setMenudemopages(temp);
			} else if (token.user_roles_id > 2 && token.permission.length > 0) {
				const tempmap = [...sitemenu];
				const temp = { ...demoPages };
				delete temp.e_complete;
				delete temp.e_pending;
				tempmap.forEach((b, i) => {
					let mainindex;

					if (
						token.permission.some((Item, r) => {
							if (Item.parent_module == b.value) {
								mainindex = r;
								return true;
							}
							return false;
						})
					) {
						tempmap[i].active = true;
						if (tempmap[i].subMenu !== undefined) {
							const submenu = [...tempmap[i].subMenu];
							submenu.forEach((a, s) => {
								let tempindex;

								if (
									token.permission.some((Sub, i) => {
										if (Sub.module_name == a.value) {
											tempindex = i;
											return true;
										}
										return false;
									})
								) {
									submenu[s].active = true;
									if (tempindex != undefined) {
										setPathpermission((p) => {
											const temp = [...p];
											const index = temp.findIndex((r) => {
												return r.path == a.path;
											});
											if (index !== -1) {
												const term = { ...temp[index] };
												term.permission =
													token.permission[tempindex].permission;
												temp[index] = term;
											} else {
												temp.push({
													path: a.path,
													permission:
														token.permission[tempindex].permission,
												});
											}

											return temp;
										});
									}
								}
							});
							tempmap[i].subMenu = submenu;
						} else {
							if (mainindex != undefined) {
								if (token.permission[mainindex].permission != undefined) {
									setPathpermission((p) => {
										const temp = [...p];
										const index = temp.findIndex((r) => {
											return r.path == b.path;
										});
										if (index !== -1) {
											const term = { ...temp[index] };
											term.permission =
												token.permission[mainindex].permission;
											temp[index] = term;
										} else {
											temp.push({
												path: b.path,
												permission: token.permission[mainindex].permission,
											});
										}

										return temp;
										// const temp = [...p];
										// temp.push({
										// 	path: b.path,
										// 	permission: token.permission[mainindex].permission,
										// });
										// return temp;
									});
								}
							}
						}
					}
				});
				tempmap.forEach((b) => {
					if (!b.active) {
						delete temp[b.key];
					} else {
						if (b.subMenu !== undefined) {
							b.subMenu.forEach((q) => {
								if (!q.active) {
									temp[b.key].subMenu[q.key].hide = true;
								} else {
									if (temp[b.key].subMenu[q.key] != undefined) {
										temp[b.key].subMenu[q.key].hide = false;
									}
								}
							});
						}
					}
				});
				temp.e_reports.subMenu.e_app_book.hide = true;
				temp.e_reports.subMenu.e_sched_book.hide = true;

				setMenudemopages(temp);
			} else if (token.is_worker_emp === 1 && token.permission.length === 0) {
			// } else if (token.user_roles_id === 2 && token.permission.length === 0) {
				const temp = { ...demoPages };
				delete temp.vbookingPages;
				delete temp.Orders_v;
				delete temp.servicePages;
				delete temp.addProduct;
				delete temp.sliderSetting;
				delete temp.branchList;
				delete temp.Manage_e;
				delete temp.Manage_u;
				delete temp.Transaction;
				delete temp.Manage_report;
				delete temp.Manage_refunds;

				setMenudemopages(temp);
			}
		} else {
			const temp = { ...demoPages };
			delete temp.e_complete;
			delete temp.e_pending;
			delete temp.vbookingPages;
			delete temp.Orders_v;
			delete temp.servicePages;
			delete temp.addProduct;
			delete temp.sliderSetting;
			delete temp.branchList;
			delete temp.Manage_e;
			delete temp.Manage_u;
			delete temp.Transaction;
			delete temp.Manage_report;
			delete temp.Manage_refunds;
			temp.e_reports.subMenu.e_app_book.hide = true;
			temp.e_reports.subMenu.e_sched_book.hide = true;
			setMenudemopages(temp);
		}
	}, [token?.session_key]);
	// }, [token?.session_key, reset]);
	useEffect(() => {
		let reftimeout;

		if (token.user_roles_id) {
			reftimeout = setTimeout(() => {
				let isallow = false;
				const path = `${location.pathname}`.substring(1);
				Object.keys(menudemopages).forEach((a) => {
					if (menudemopages[a].subMenu != undefined) {
						Object.keys(menudemopages[a].subMenu).forEach((b) => {
							if (menudemopages[a].subMenu[b].hide != true) {
								if (menudemopages[a].subMenu[b].path === path) {
									isallow = true;
								}
							}
						});
					}
				});
				if (
					path !== 'dashboard' &&
					path !== 'Leave' &&
					path !== 'orders' &&
					path !== 'viewproducts' &&
					path !== 'sliders' &&
					path !== 'customers' &&
					path !== 'branch' &&
					path !== 'settings'
				) {
					if (!isallow) {
						// navigate('/dashboard');
					}
				}

				setLoading(false);
			}, 1000 * 2);
		}
		return () => {
			clearTimeout(reftimeout);
		};
	}, [location.pathname, token?.session_key, menudemopages]);
	const values = useMemo(
		() => ({
			token,
			menudemopages,
			pathpermission,
			setToken,
			setReset,
		}),
		[token?.session_key, menudemopages, pathpermission],
	);

	return <userAuth.Provider value={values}>{children}</userAuth.Provider>;
};

export default UserContextProvider;
